module.exports = __webpack_public_path__ + "static/tanalog_banner-708fe902973c0ce74a167b57934f2003.jpg";